import { AllPreference } from '@@types/Preference';

import i18n from '~/i18n';
import WebsocketConnector from '~/services/WebsocketConnector';
import Actions from '~/stores/Actions';
import { globalSettingStore } from '~/stores/GlobalSettingStore';
import { slashCommandAppsStore } from '~/stores/SlashCommandAppsStore';
import last from 'ramda/es/last';
import map from 'ramda/es/map';
import pipe from 'ramda/es/pipe';
import prop from 'ramda/es/prop';
import split from 'ramda/es/split';

class CommonMessageHandler {
  constructor(private ws: WebsocketConnector, private actions: Actions) {}

  handleUpdateMemberPreference = (preferences: AllPreference[]) => {
    map(globalSettingStore.updatePreference, preferences);
  };

  handleUpdateStreamPush = (content) => {
    globalSettingStore.setDoorayNews(content);
  };

  handleDisplayToastContinuous = (text) => {
    this.actions.notificationActions.showInfo({ text, timeout: 0 });
  };

  handleToast = (text) => {
    this.actions.notificationActions.showError({ text });
  };

  handleServerUpgrade = () => {
    this.actions.notificationActions.showInfo({
      text: i18n.t('serverUpgrade', '메신저가 업데이트 되었습니다. <br/>최신 버전을 이용하시려면 새로고침하십시오.'),
      timeout: 0,
      noDismiss: true,
      action: {
        label: 'OK',
        callback: () => window.location.reload(),
      },
    });
  };

  handleConnectSameSession = () => {
    this.ws.setStopRetry(true);
  };

  handleMemberWithdraw = () => {};

  handleDialogOpen = (content) => {
    const clientTimestamp = pipe<any, any, any, any>(prop('triggerId'), split('.'), last)(content);

    const targetChannelId = slashCommandAppsStore.commandTimestampMap[clientTimestamp];
    if (!targetChannelId) return;

    delete slashCommandAppsStore.commandTimestampMap[clientTimestamp];

    this.actions.modalActions.openCommandAction(Object.assign({}, content, { channelId: targetChannelId }));
  };
}

export default CommonMessageHandler;
